import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import config from '../../config';
import usePlanFeatures from '../../hooks/usePlanFeatures';
import { onPlanRefusal } from '../../utils/planRefusal';
import { PlanChangeButton } from './PlanRequest';
import './sandbox.css';

/**
 * Above the chat: why the assistant does not answer when the person's plan leaves chat out (docs/SANDBOX_FIRST.md).
 *
 * Shown when a chat turn came back with mia-flow-bff's 403 `plan_feature` (utils/planRefusal.js), and before any turn
 * when the overview already says chat cannot work: neither the organization's models nor an own key are in the plan.
 * Dismissed, it comes back with the next refused turn.
 */
export default function PlanRefusalNotice() {
  const { planName, chatOrgModels, chatOwnKey } = usePlanFeatures();
  const [refused, setRefused] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => onPlanRefusal(() => {
    setRefused(true);
    setDismissed(false);
  }), []);

  const notInPlan = !chatOrgModels && !chatOwnKey;
  if (dismissed || !(refused || notInPlan)) { return null; }
  const settingsPath = config.sandboxFirst ? '/features/chat' : '/settings';
  return (
    <div className="sbx-card sbx-plan-notice" role="alert">
      <div className="sbx-plan-notice-text">
        <strong>Chat isn’t included in your plan{planName ? ` (${planName})` : ''}.</strong>
        <span>
          {chatOwnKey ? 'Add your own model key, ask your sandbox admin, or use your AI tool with the sandbox.'
            : 'Ask your sandbox admin, or use your AI tool with the sandbox.'}
        </span>
        <span className="sbx-plan-notice-links">
          <Link to={settingsPath}>See what your plan includes</Link>
          <PlanChangeButton />
        </span>
      </div>
      <button aria-label="Dismiss" className="sbx-plan-notice-close" onClick={() => setDismissed(true)} type="button">×</button>
    </div>
  );
}
